import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconThumbsUp20Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconThumbsUp20Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.5 8.053a2.5 2.5 0 0 0-2.5 2.5V14.5A2.5 2.5 0 0 0 4.5 17H5V8.053zm2-1.007V17h7.001a2.5 2.5 0 0 0 2.239-1.387l1.963-3.947c.826-1.662-.382-3.613-2.238-3.613H12.35l.296-3.434c.12-1.396-1.572-2.18-2.56-1.185z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconThumbsUp20Filled);
